import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertySearch',
  pure: true, // performant for large lists
})
export class PropertySearchPipe implements PipeTransform {
  transform(properties: any[], searchText: string): any[] {
    if (!properties || !searchText) {
      return properties;
    }

    const text = searchText.toLowerCase().trim();

    return properties.filter((property) => {
      const nameMatch = property?.name?.toLowerCase().includes(text);

      const typeMatch = property?.propertyType?.toLowerCase().includes(text);

      const bedMatch = property?.bedrooms?.toString().includes(text);

      const priceMatch = property?.price?.toString().includes(text);

      return nameMatch || typeMatch || bedMatch || priceMatch;
    });
  }
}
